var _path, _circle, _polyline, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 161.2 161.2",
    enableBackground: "new 0 0 161.2 161.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path",
    fill: "none",
    stroke: "#0d5c75",
    strokeMiterlimit: 10,
    d: "M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4                                 c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5                                 c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "path",
    fill: "none",
    stroke: "#0d5c75",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 80.6,
    cy: 80.6,
    r: 62.1
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "path",
    fill: "none",
    stroke: "#0d5c75",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "113,52.8                                 74.1,108.4 48.2,86.4 "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "spin",
    fill: "none",
    stroke: "#0d5c75",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeDasharray: "12.2175,12.2175",
    cx: 80.6,
    cy: 80.6,
    r: 73.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.3613f2e559502074e1ecbfb0afa4b57e.svg";
export { ForwardRef as ReactComponent };